import * as types from "../actions/types";

const initialState = {
    waitingDeploymentCount: null,
    deploymentslist: null,
    isDeploying: false
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_DEPLOYMENTSLIST_COMPLETED:
            return Object.assign({}, state, {
                deploymentslist: action.payload
            });
        case types.CREATE_DEPLOYMENT:
            return Object.assign({}, state, {
                isDeploying: true
            });
        case types.GET_WAITINGDEPLOYMENTSCOUNT_COMPLETED:
            return Object.assign({}, state, {
                waitingDeploymentCount: action.payload
            });
        case types.CREATE_DEPLOYMENT_COMPLETED:
        case types.CREATE_DEPLOYMENT_FAILED:
            return Object.assign({}, state, {
                isDeploying: false
            });
        default:
            return state;
    }
};
